// ----------------------------------------------------------------------
import { _id } from 'src/_mock/assets';

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  ACCOUNT: '/account',
  CONTACT: '/contact',
  FORM: '/form',
  CHAT: '/chat',
  CAMPAIGN: '/campaign',
  SETTING: '/setting',
  CHANNEL: '/channel',
  TENANT: '/tenant',
  TICKET: '/ticket',
  REPORT: '/report',
  PROFILE: '/profile',
};

const MOCK_ID = _id[1];

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  minimalStore: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    signIn: `${ROOTS.AUTH}/sign-in`,
    signUp: `${ROOTS.AUTH}/sign-up`,
    verify: `${ROOTS.AUTH}/verify`,
    updatePassword: `${ROOTS.AUTH}/update-password`,
    resetPassword: `${ROOTS.AUTH}/reset-password`,
    // amplify: {
    //   signIn: `${ROOTS.AUTH}/amplify/sign-in`,
    //   verify: `${ROOTS.AUTH}/amplify/verify`,
    //   signUp: `${ROOTS.AUTH}/amplify/sign-up`,
    //   updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
    //   resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    // },
    // jwt: {
    //   signIn: `${ROOTS.AUTH}/sign-in`,
    //   signUp: `${ROOTS.AUTH}/sign-up`,
    // },
    // firebase: {
    //   signIn: `${ROOTS.AUTH}/firebase/sign-in`,
    //   verify: `${ROOTS.AUTH}/firebase/verify`,
    //   signUp: `${ROOTS.AUTH}/firebase/sign-up`,
    //   resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    // },
    // auth0: {
    //   signIn: `${ROOTS.AUTH}/auth0/sign-in`,
    // },
    // supabase: {
    //   signIn: `${ROOTS.AUTH}/supabase/sign-in`,
    //   verify: `${ROOTS.AUTH}/supabase/verify`,
    //   signUp: `${ROOTS.AUTH}/supabase/sign-up`,
    //   updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
    //   resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    // },
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
  },
  contact: {
    root: `${ROOTS.CONTACT}`,
    list: `${ROOTS.CONTACT}/list`,
    details: (id: string) => `${ROOTS.CONTACT}/${id}/details`,
    demo: {
      details: `${ROOTS.CONTACT}/${MOCK_ID}/details`,
    },
  },
  account: {
    root: `${ROOTS.ACCOUNT}`,
    list: `${ROOTS.ACCOUNT}/list`,
    details: (id: string) => `${ROOTS.ACCOUNT}/${id}/details`,
    demo: {
      details: `${ROOTS.ACCOUNT}/${MOCK_ID}/details`,
    },
  },
  form: {
    root: `${ROOTS.FORM}`,
  },
  campaign: {
    root: `${ROOTS.CAMPAIGN}`,
    step: `${ROOTS.CAMPAIGN}/step`,
    details: (id: string) => `${ROOTS.CAMPAIGN}/${id}/details`,
  },
  channel: {
    root: `${ROOTS.CHANNEL}`,
    step: `${ROOTS.CHANNEL}/step`,
    edit: (id: string) => `${ROOTS.CHANNEL}/${id}/edit`,
  },
  chat: {
    root: `${ROOTS.CHAT}`,
    all: `${ROOTS.CHAT}/all`,
    mine: `${ROOTS.CHAT}/mine`,
    unassigned: `${ROOTS.CHAT}/unassigned`,
    whatsapp: `${ROOTS.CHAT}/whatsapp`,
    email: `${ROOTS.CHAT}/email`,
    voice: `${ROOTS.CHAT}/voice`,
    'live-chat': `${ROOTS.CHAT}/live-chat`,
  },
  setting: {
    root: `${ROOTS.SETTING}`,
    organization: `${ROOTS.SETTING}/organization`,
    user: {
      root: `${ROOTS.SETTING}/user`,
      details: (id: string) => `${ROOTS.SETTING}/user/${id}/details`,
    },
    // teams: `${ROOTS.SETTING}/teams`,
    teams: {
      root: `${ROOTS.SETTING}/teams`,
      details: (id: string) => `${ROOTS.SETTING}/teams/${id}/details`,
    },
    'custom-labels': `${ROOTS.SETTING}/custom-labels`,
    template: `${ROOTS.SETTING}/template`,
    'whatsapp-template': `${ROOTS.SETTING}/whatsapp-template`,
    'did-manage': `${ROOTS.SETTING}/did-manage`,
    billing: `${ROOTS.SETTING}/billing`,
    webhook: `${ROOTS.SETTING}/webhook`,
  },
  profile: `${ROOTS.PROFILE}`,
  report: {
    root: `${ROOTS.REPORT}`,
    'call-logs': `${ROOTS.REPORT}/call-logs`,
  },
  tenant: {
    root: `${ROOTS.TENANT}`,
    list: `${ROOTS.TENANT}/list`,
    details: (id: string) => `${ROOTS.TENANT}/${id}/details`,
  },
  ticket: {
    root: `${ROOTS.TICKET}`,
    list: `${ROOTS.TICKET}/list`,
    details: (id: string) => `${ROOTS.TICKET}/${id}/details`,
  },
};
